/**
 * @internal
 */
export class DatasourceMock {
    init(options, fetchMeta) {
        return Promise.resolve(this.initialized);
    }
    deinit() { }
    validResourceName(resourceName) {
        if (!resourceName)
            return false;
        if (!resourceName.trim().length)
            return false;
        return true;
    }
    getMetadata(resourceName) {
        return Promise.resolve(this.fieldMetadata);
    }
    snapshot(params) { }
    snapshotFiltered(rowId) { }
    updateData(data) {
        return Promise.resolve();
    }
    dataHandler(data) {
        return [];
    }
    addView(view) { }
    dropView(view) { }
    setFilter(name, value, type) {
        return Promise.resolve();
    }
    clearFilter(name) {
        return Promise.resolve();
    }
    createItem(data) {
        return Promise.resolve('');
    }
    deleteItem(itemId) {
        return Promise.resolve();
    }
    updateItem(itemId, data) {
        return Promise.resolve();
    }
}
